import CrudService from "services/cruds-service";

export const getPermissions = async (userId) => {
  try {
    const { data, included = [] } = await CrudService.getUserWithPermissions(userId);

    /* 1. allowedPages -> "view" kuralları  */
    const pageRules =
        data?.attributes?.role?.allowedPages?.map((p) => ({ action: "view", subject: p })) || [];

    /* 2. roles.permissions -> action/subject kuralları  */
    const permRules = included
        .filter((i) => i.type === "permissions")
        .map((perm) => {
          const [action, subject] = perm.attributes.name.split(" ");

          // "delete users" veya "edit users" ise kendisini hariç tut
          if (
              ["delete", "edit"].includes(action) &&
              subject === "users"
          ) {
            return { action, subject, conditions: { id: { $ne: userId } } };
          }
          return { action, subject };
        });

    return [...pageRules, ...permRules];
  } catch (err) {
    console.error("getPermissions error:", err);
    return []; // Ability.update boş dizi alırsa tüm yetkileri sıfırlar
  }
};
